import { Trophy } from "lucide-react";
import { MODELS } from "../lib/models";

export const MindBadge = ({ turn }) => {
  const changed = turn.mind_changed || [];
  if (!changed.length) return null;
  const names = changed.map((k) => MODELS.find((m) => m.key === k)?.name || k);
  const list = names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}` : names[0];
  return (
    <div data-testid="mind-changed-badge" className="what-mind-badge mt-6">
      <span className="what-mind-trophy"><Trophy size={22} /></span>
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#0B0F17]/70">Badge earned · Mind changer</p>
        <p data-testid="mind-changed-title" className="font-display text-lg font-extrabold text-[#0B0F17]">
          You changed {list}'s mind!
        </p>
        {turn.mind_reason && <p data-testid="mind-changed-reason" className="text-sm text-[#0B0F17]/80 mt-0.5">{turn.mind_reason}</p>}
      </div>
    </div>
  );
};
